<template>
	<div data-component="landing" data-page="index.page">
		<Header v-bind="headerContent" />

		<main>
			<section
				v-for="section in sections"
				:key="section.id"
				v-bot:event="section.botEvent"
				class="landing-section"
				:data-section-id="section.id"
			>
				<component :is="section.component" v-bind="section.props" />
			</section>
		</main>

		<Footer v-bind="content.footer" />
	</div>
</template>

<script setup>
import content from './content'
import { Header, TitleWithTag, TextWithImage, ImageSet, PageCount } from './sections'
import { Footer } from '../../sections'

defineOptions({
	name: 'LandingPage',
})

const sectionComponentMap = {
	titleWithTag: TitleWithTag,
	imageSet: ImageSet,
	pageCount: PageCount,
	textWithImage: TextWithImage,
}

const headerContent = {
	heroImage: content.header.heroImage,
	titleLine1: content.header.titleLine1,
	titleLine2: content.header.titleLine2,
}

const sections = content.sections.reduce((resolvedSections, section) => {
	const component = sectionComponentMap[section._type]

	if (!component) {
		if (import.meta.dev) {
			console.warn(`[Landing] Unknown section type "${section._type}" for section "${section.id}".`)
		}
		return resolvedSections
	}

	resolvedSections.push({
		id: section.id,
		props: section.props,
		component,
		botEvent: section.botEvent,
	})

	return resolvedSections
}, [])
</script>

<style lang="scss" scoped>
[data-component='landing'] {
	position: relative;
}
</style>
